module.exports = __webpack_public_path__ + "static/media/no-future-events.dd2e46ab.png";